import api from "../..";
import type { Event, EventDetail, GetEventByIdParams, GetEventsParams } from "./types";

export const getEvents = async (input: GetEventsParams = {}): Promise<Event[]> => {

  const { params } = input;

  return await api.get("/event/", { params })
  .then(res => res.data.data)
  .catch(() => {return []});
};

export const getEventById = async ({ id }: GetEventByIdParams): Promise<EventDetail | null> => {

  return await api.get(`/event/${id}/`)
  .then(res => res.data.data)
  .catch(() => {return null});
};
